/** The chart blocks the series endpoint can answer with; one per card on the insights page. */
export var SurveySeriesPart;
(function (SurveySeriesPart) {
    SurveySeriesPart["SCORE"] = "SCORE";
    SurveySeriesPart["HEALTH"] = "HEALTH";
    SurveySeriesPart["REACH"] = "REACH";
    SurveySeriesPart["SENTIMENT"] = "SENTIMENT";
    SurveySeriesPart["RESPONSES"] = "RESPONSES";
    SurveySeriesPart["NPS"] = "NPS";
})(SurveySeriesPart || (SurveySeriesPart = {}));
/**
 * What a survey can be split by. Resources carry no type of their own, only the
 * categories the organisation gave them, so each category is its own group.
 */
export var SurveyBreakdownDimension;
(function (SurveyBreakdownDimension) {
    SurveyBreakdownDimension["SERVICE"] = "SERVICE";
    SurveyBreakdownDimension["RESOURCE_CATEGORY"] = "RESOURCE_CATEGORY";
    SurveyBreakdownDimension["SECTOR"] = "SECTOR";
    SurveyBreakdownDimension["LANGUAGE"] = "LANGUAGE";
    SurveyBreakdownDimension["QUESTION"] = "QUESTION";
})(SurveyBreakdownDimension || (SurveyBreakdownDimension = {}));
/** The eight figures of the insights introduction, in the order the band shows them. */
export var SurveyIntroductionMetric;
(function (SurveyIntroductionMetric) {
    SurveyIntroductionMetric["CRQLAR_SCORE"] = "CRQLAR_SCORE";
    SurveyIntroductionMetric["SATISFACTION"] = "SATISFACTION";
    SurveyIntroductionMetric["NPS"] = "NPS";
    SurveyIntroductionMetric["INVITATIONS"] = "INVITATIONS";
    SurveyIntroductionMetric["SUBMISSIONS"] = "SUBMISSIONS";
    SurveyIntroductionMetric["RESPONSE_RATE"] = "RESPONSE_RATE";
    SurveyIntroductionMetric["TIME_TO_RESPOND"] = "TIME_TO_RESPOND";
    SurveyIntroductionMetric["FILL_OUT_TIME"] = "FILL_OUT_TIME";
})(SurveyIntroductionMetric || (SurveyIntroductionMetric = {}));
/** What a metric's number means, so the client can format it without knowing the metric. */
export var SurveyIntroductionUnit;
(function (SurveyIntroductionUnit) {
    SurveyIntroductionUnit["POINTS"] = "POINTS";
    SurveyIntroductionUnit["PERCENT"] = "PERCENT";
    SurveyIntroductionUnit["COUNT"] = "COUNT";
    SurveyIntroductionUnit["SECONDS"] = "SECONDS";
})(SurveyIntroductionUnit || (SurveyIntroductionUnit = {}));
/** One range's funnel, from everyone who could have been asked down to everyone who finished. */
/** What the reach outcomes are counted over: the invitations sent, or - on an anonymous survey - its visits. */
export var SurveyReachBasis;
(function (SurveyReachBasis) {
    SurveyReachBasis["INVITATIONS"] = "INVITATIONS";
    SurveyReachBasis["VISITS"] = "VISITS";
})(SurveyReachBasis || (SurveyReachBasis = {}));
